"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import classNames from "classnames";
import React, { forwardRef } from "react";
import * as styles from "./Text-css";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
export const Text = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      size = "m",
      strong,
      secondary,
      element: TextElement = "span",
      align,
      theme,
      className,
      id,
      children,
      lineHeight = "relaxed",
      truncate,
      hidden
    } = _b, rest = __objRest(_b, [
      "size",
      "strong",
      "secondary",
      "element",
      "align",
      "theme",
      "className",
      "id",
      "children",
      "lineHeight",
      "truncate",
      "hidden"
    ]);
    return /* @__PURE__ */ React.createElement(
      TextElement,
      __spreadValues({
        id,
        className: classNames(
          "kl-text",
          className,
          `kl-text--size-${size}`,
          `kl-text--line-height-${lineHeight}`,
          {
            [darkTheme]: theme === "dark",
            [lightTheme]: theme === "dark",
            "kl-text--strong": strong,
            "kl-text--secondary": secondary,
            [`kl-text--align-${align}`]: align
          },
          styles.text({ size, strong, secondary, align, lineHeight, truncate, hidden })
        ),
        ref
      }, rest),
      children
    );
  }
);
